const Logo = () => {
  return (
    <div style={{width: '30', height: '30' }} className='d-inline-block align-top logo'>
      Digihappy
    </div>
  )
}

export default Logo
